import React from 'react'

import { Link } from '@ui/components/Link'

import { UrlPattern } from './formValidation'

export const linkify = (text: string) => {
  if (!text) return text
  const decodedText = decodeHtmlEntities(text)

  const urlRegex = new RegExp(UrlPattern.source.replace(/^\^|\$$/g, ''), 'g')
  const elements: React.ReactNode[] = []
  let lastIndex = 0
  let match
  while ((match = urlRegex.exec(decodedText)) !== null) {
    if (match.index > lastIndex) {
      elements.push(decodedText.slice(lastIndex, match.index))
    }
    const url = match[0].startsWith('www.') ? `http://${match[0]}` : match[0]
    elements.push(
      <Link key={match.index} href={url}>
        {match[0]}
      </Link>
    )
    lastIndex = urlRegex.lastIndex
  }
  if (lastIndex < decodedText.length) {
    elements.push(decodedText.slice(lastIndex))
  }

  return elements
}

const decodeHtmlEntities = (str: string): string => {
  if (!str) return str
  return str
    .replace(/&nbsp;/g, ' ')
    .replace(/\u00A0/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
}
